module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagep"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "32",
      "src": "images/stara.jpg",
      "width": "109"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('p', {
    staticClass: "chtitle",
    attrs: {
      "id": "rch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "href": "#/Contents#ch01"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "normalta"
  }, [_c('span', [_vm._v("We’ve all watched action-packed military movies in which an extraordinary soldier carries out a series of heroic acts to successfully complete a mission. Films such as "), _c('i', [_vm._v("Rambo, Act of Valor, Lone Survivor, Jarhead")]), _vm._v(" and "), _c('i', [_vm._v("The Delta Force")]), _vm._v(" always motivated me to maintain a high level of fitness and also raised my interest in the methods of fitness training special operations groups such as Navy SEALs, Green Berets and Army Rangers partake in. As it turns out, movies only show a portion of the rigorous physical training these soldiers put themselves through daily to become elite soldiers.")])]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('span', [_vm._v("Since 2009, I’ve served as a strength and conditioning specialist for various U.S. military branches. During this time I’ve been fortunate to have trained some of the most elite soldiers in the world. I created "), _c('i', [_vm._v("Special Forces Fitness Training")]), _vm._v(" to offer a different and convenient method for soldiers to perform physical training regardless of their location and deployment status.")])]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('span', [_c('i', [_vm._v("Special Forces Fitness Training")]), _vm._v(" consists of workouts I created while training personnel of the Army, Air Force, Navy and Marines. Soldiers that utilized this program became stronger, faster and leaner, and also sustained fewer injuries than they did prior to performing this program. How is this possible? Well, just like collegiate or professional athletes, soldiers are required to have speed, agility, strength, balance, endurance, flexibility, quick reflexes and mental toughness. In other words: To be a badass, train like one!")])]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('span', [_vm._v("The unique thing about this program is that it not only provides exercise from an athletic spectrum, but also a military spectrum. In this book you’ll find 30 different workouts involving the core (abs), upper body, total body, martial arts and much more. No other program offers this combination. Regardless of your gender or fitness level, I can promise that if you push yourself and commit to the program, you’ll achieve your desired results.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagev"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "350",
      "src": "images/p6.jpg",
      "width": "640"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b6c9128","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter01.vue
// module id = 75
// module chunks = 0